// src/types/bookings/BookingModification.ts
var BookingModificationMode = /* @__PURE__ */ ((BookingModificationMode2) => {
  BookingModificationMode2["Reschedule"] = "RESCHEDULE";
  BookingModificationMode2["Extend"] = "EXTEND";
  BookingModificationMode2["UnitChange"] = "UNIT_CHANGE";
  return BookingModificationMode2;
})(BookingModificationMode || {});
var BookingModificationStatus = /* @__PURE__ */ ((BookingModificationStatus2) => {
  BookingModificationStatus2["AwaitingApproval"] = "awaiting_approval";
  BookingModificationStatus2["AwaitingPayment"] = "awaiting_payment";
  BookingModificationStatus2["Applied"] = "applied";
  BookingModificationStatus2["Declined"] = "declined";
  BookingModificationStatus2["Cancelled"] = "cancelled";
  BookingModificationStatus2["Expired"] = "expired";
  return BookingModificationStatus2;
})(BookingModificationStatus || {});
var BookingModificationDirection = /* @__PURE__ */ ((BookingModificationDirection2) => {
  BookingModificationDirection2["Charge"] = "CHARGE";
  BookingModificationDirection2["Refund"] = "REFUND";
  BookingModificationDirection2["None"] = "NONE";
  return BookingModificationDirection2;
})(BookingModificationDirection || {});

export {
  BookingModificationMode,
  BookingModificationStatus,
  BookingModificationDirection
};
